import { useCallback, useMemo, useState } from "react";

import { ImageComponent } from "../../../../components";
import FormattedText from "../../../../components/FormattedText/FormattedText";
import { DownArrow } from "../../../../icons/DownArrow";
import { Card, CardPadding } from "../../Claims.style";
import { FAQ_CONSTANTS } from "./constants";
import {
  AnswerText,
  ChevronWrapper,
  FAQItemButton,
  FAQItemContainer,
  FAQList,
  Header,
  QuestionText,
  SectionTitle,
  ViewAllButton,
} from "./FAQCard.style";
import { FAQDrawer } from "./FAQDrawer";
import type { FAQCardProps } from "./types";

export function FAQCard({
  title,
  headingActionTitle,
  headingIcon,
  displayNumber = FAQ_CONSTANTS.DEFAULT_PREVIEW_COUNT,
  headerTitle,
  actionCards,
}: FAQCardProps) {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const previewCards = useMemo(
    () => (actionCards ?? []).slice(0, displayNumber),
    [actionCards, displayNumber]
  );

  const toggleItem = useCallback((index: number) => {
    setExpandedIndex((prev) => (prev === index ? null : index));
  }, []);

  const openDrawer = useCallback(() => {
    setIsDrawerOpen(true);
  }, []);

  const closeDrawer = useCallback(() => {
    setIsDrawerOpen(false);
  }, []);

  if (previewCards.length === 0) return null;

  return (
    <>
      <Card>
        <CardPadding>
          <Header>
            {title ? (
              <SectionTitle>
                <FormattedText value={title} />
              </SectionTitle>
            ) : null}
            {headingActionTitle && (actionCards?.length ?? 0) > 0 ? (
              <ViewAllButton onClick={openDrawer}>
                <FormattedText value={headingActionTitle} />
                {headingIcon ? (
                  <ImageComponent
                    src={headingIcon}
                    width="14px"
                    height="14px"
                    alt=""
                  />
                ) : null}
              </ViewAllButton>
            ) : null}
          </Header>

          <FAQList>
            {previewCards.map((faq, index) => {
              const isExpanded = expandedIndex === index;
              return (
                <FAQItemContainer key={faq.title ?? index}>
                  <FAQItemButton
                    onClick={() => toggleItem(index)}
                    aria-expanded={isExpanded}
                  >
                    {faq.title ? (
                      <QuestionText>{faq.title}</QuestionText>
                    ) : null}
                    <ChevronWrapper $isExpanded={isExpanded}>
                      <DownArrow />
                    </ChevronWrapper>
                  </FAQItemButton>
                  {isExpanded && faq.description ? (
                    <AnswerText>{faq.description}</AnswerText>
                  ) : null}
                </FAQItemContainer>
              );
            })}
          </FAQList>
        </CardPadding>
      </Card>

      <FAQDrawer
        isOpen={isDrawerOpen}
        onClose={closeDrawer}
        headerTitle={headerTitle}
        actionCards={actionCards}
      />
    </>
  );
}
